import { createContext } from "react";

export type DeploymentAccessStatus = "loading" | "granted" | "forbidden" | "error";

export type DeploymentAccessContextValue = {
  status: DeploymentAccessStatus;
  hasAdminAccess: boolean;
  refreshAccess: () => Promise<void>;
};

export const DeploymentAccessContext = createContext<DeploymentAccessContextValue | null>(
  null,
);
